import React from "react";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";
import { useRef, useState } from "react";
import IdleTimer from "react-idle-timer";
import { Box } from "@mui/system";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";

const BootstrapButton = styled(Button)({
  background: "#6cca98",
  color: "#fff",
  "&:hover": {
    background: "#6cca98",
    color: "#fff",
  },
  "&:disabled": {
    color: "rgba(0, 0, 0, 0.38)",
    cursor: "not-allowed",
    background: "#E4E5E8",
  },
});

export const ConnectIdleTimerComponent = ({ isConsultation, signOut }) => {
  const [timeoutDuration] = useState(1000 * 60 * 60 * 8);
  const [debounceDuration] = useState(750);
  const [openPopup, setOpenPopup] = useState(false);
  const [isTimedOut, setIsTimedOut] = useState(false);
  const [counter, setCounter] = useState(5);
  const isRetail = JSON.parse(localStorage.getItem("isRetail"));
  const idleTimer = useRef();

  const onAction = () => {
    setIsTimedOut(false);
  };

  const onActive = (event) => {
    setIsTimedOut(false);
  };

  const startCounterTimer = () => {
    let start = 5;
    this.timer = setInterval(() => {
      start -= 1;
      setCounter(start);
      if (start === 0) {
        setOpenPopup(false);
        setCounter(5);
        clearInterval(this.timer);
        setTimeout(() => signOut(), 1000);
      }
    }, 1500);
  };

  const onIdle = (event) => {
    if (!isTimedOut && isConsultation) {
      setOpenPopup(true);
      idleTimer.current.reset();
      setIsTimedOut(true);
      startCounterTimer();
    }
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
    clearInterval(this.timer);
  };

  const handleYes = () => {
    setOpenPopup(false);
    clearInterval(this.timer);
    setTimeout(() => setCounter(5), 1000);
  };

  const handleNo = () => {
    setOpenPopup(false);
    setTimeout(() => {
      signOut();
      setCounter(5);
    }, 1000);
  };

  const { t } = useTranslation();

  return (
    <React.Fragment>
      <IdleTimer
        ref={idleTimer}
        element={document}
        onActive={onActive}
        onIdle={!isRetail ? onIdle : ""}
        onAction={onAction}
        debounce={debounceDuration}
        timeout={timeoutDuration}
      />

      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        open={openPopup}
        onClose={handleClosePopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          style: {
            borderRadius: "5px",
            width: "300px",
          },
        }}
      >
        <DialogContent>
          <Box
            sx={{ textAlign: "center", fontWeight: "400", fontSize: "20px" }}
          >
            {t("Home.IdlePopup.AreYouStillWorking")}
          </Box>
          <Box
            sx={{ textAlign: "center", fontWeight: "600", fontSize: "30px" }}
          >
            {counter}
          </Box>
        </DialogContent>
        <DialogActions>
          <BootstrapButton onClick={handleYes} color="primary">
            {t("Home.IdlePopup.Yes")}
          </BootstrapButton>
          <BootstrapButton onClick={handleNo} color="primary">
            {t("Home.IdlePopup.No")}
          </BootstrapButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ConnectIdleTimerComponent.js